import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "cofounder-ranks" }
const _hoisted_2 = { class: "flex-grow-1" }
const _hoisted_3 = { class: "fw-bold fs-5" }
const _hoisted_4 = { class: "small" }
const _hoisted_5 = { class: "text-end small text-nowrap" }
const _hoisted_6 = { class: "text-muted" }
const _hoisted_7 = {
  key: 0,
  class: "alert alert-danger py-2 small mb-2"
}
const _hoisted_8 = {
  key: 1,
  class: "alert alert-warning py-2 small mb-2"
}
const _hoisted_9 = { class: "table-responsive" }
const _hoisted_10 = { class: "table table-sm table-bordered align-middle tabla mb-2" }
const _hoisted_11 = { class: "col-check" }
const _hoisted_12 = ["disabled", "checked", "title", "aria-label", "onChange"]
const _hoisted_13 = { class: "badge-id" }
const _hoisted_14 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_15 = { key: 1 }
const _hoisted_16 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_17 = ["title"]
const _hoisted_18 = {
  key: 1,
  class: "badge bg-danger ms-1",
  title: 'El default de placeMember. Cobra la mitad y nada lo dice.'
}
const _hoisted_19 = ["title"]
const _hoisted_20 = {
  key: 1,
  class: "badge bg-success"
}
const _hoisted_21 = {
  key: 2,
  class: "badge bg-danger"
}
const _hoisted_22 = {
  key: 2,
  class: "alert alert-success py-2 small mb-2"
}
const _hoisted_23 = { class: "mb-0" }
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["veredicto d-flex align-items-center gap-3 p-3 mb-3 rounded", _ctx.report.veredicto.aplicado ? 'v-verde' : 'v-rojo'])
    }, [
      _createElementVNode("i", {
        class: _normalizeClass(["fas fa-2x", 
          _ctx.report.veredicto.aplicado
            ? 'fa-circle-check'
            : 'fa-triangle-exclamation'
        ])
      }, null, 2),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.report.veredicto.aplicado
              ? "LOS FUNDADORES ESTÁN COMPLETOS"
              : "FALTA ESCRIBIR ALGO"), 1),
        _createElementVNode("div", _hoisted_4, [
          _cache[0] || (_cache[0] = _createTextVNode(" Marca las cuentas y pulsa ", -1)),
          _cache[1] || (_cache[1] = _createElementVNode("strong", null, "Aplicar", -1)),
          _cache[2] || (_cache[2] = _createTextVNode(". A cada una marcada se le escriben ", -1)),
          _cache[3] || (_cache[3] = _createElementVNode("strong", null, "DOS", -1)),
          _cache[4] || (_cache[4] = _createTextVNode(" cosas, juntas y en dos documentos distintos: ", -1)),
          _cache[5] || (_cache[5] = _createElementVNode("code", null, "currentRank", -1)),
          _cache[6] || (_cache[6] = _createTextVNode(" = ", -1)),
          _createElementVNode("code", null, _toDisplayString(_ctx.report.rankId), 1),
          _cache[7] || (_cache[7] = _createTextVNode(" en ", -1)),
          _cache[8] || (_cache[8] = _createElementVNode("code", null, "users/", -1)),
          _cache[9] || (_cache[9] = _createTextVNode(" y ", -1)),
          _cache[10] || (_cache[10] = _createElementVNode("code", null, "binaryPercentage", -1)),
          _cache[11] || (_cache[11] = _createTextVNode(" = ", -1)),
          _createElementVNode("strong", null, _toDisplayString(_ctx.report.percentage), 1),
          _cache[12] || (_cache[12] = _createTextVNode(" en ", -1)),
          _cache[13] || (_cache[13] = _createElementVNode("code", null, "binaryTree/", -1)),
          _cache[14] || (_cache[14] = _createTextVNode(". Hacer sólo la primera es el error fácil — ", -1)),
          _cache[15] || (_cache[15] = _createElementVNode("strong", null, "el porcentaje no se deduce del rango", -1)),
          _cache[16] || (_cache[16] = _createTextVNode(". ", -1))
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", null, [
          _cache[17] || (_cache[17] = _createTextVNode(" base ", -1)),
          _createElementVNode("code", null, _toDisplayString(_ctx.report.databaseId), 1)
        ]),
        _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.hora), 1)
      ])
    ], 2),
    (_ctx.report.veredicto.enDefault.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _cache[18] || (_cache[18] = _createElementVNode("i", { class: "fas fa-circle-exclamation" }, null, -1)),
          _createElementVNode("strong", null, _toDisplayString(_ctx.report.veredicto.enDefault.length) + " nodo(s) siguen en el default de " + _toDisplayString(_ctx.report.defaultPercentage) + "%", 1),
          _cache[19] || (_cache[19] = _createTextVNode(" — ", -1)),
          _createElementVNode("code", null, _toDisplayString(_ctx.report.veredicto.enDefault.join(" · ")), 1),
          _cache[20] || (_cache[20] = _createTextVNode(". Es lo que deja ", -1)),
          _cache[21] || (_cache[21] = _createElementVNode("code", null, "placeMember", -1)),
          _cache[22] || (_cache[22] = _createTextVNode(" al crear el nodo, y el motor de rangos ", -1)),
          _cache[23] || (_cache[23] = _createElementVNode("strong", null, "no se lo corrige", -1)),
          _cache[24] || (_cache[24] = _createTextVNode(": estas cuentas están exentas de que les escriba el porcentaje, lo que las protege de que se lo REBAJE pero ", -1)),
          _cache[25] || (_cache[25] = _createElementVNode("strong", null, "tampoco se lo pone", -1)),
          _cache[26] || (_cache[26] = _createTextVNode(". Quien paga el binario lee el valor del nodo, así que tal cual está, ", -1)),
          _cache[27] || (_cache[27] = _createElementVNode("strong", null, "estos fundadores cobrarían la mitad", -1)),
          _cache[28] || (_cache[28] = _createTextVNode(" — sin error, sin log y sin que nada se vea raro. ", -1))
        ]))
      : _createCommentVNode("", true),
    (_ctx.report.veredicto.bloqueadas.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _cache[29] || (_cache[29] = _createElementVNode("i", { class: "fas fa-triangle-exclamation" }, null, -1)),
          _createElementVNode("strong", null, _toDisplayString(_ctx.report.veredicto.bloqueadas.length) + " cuenta(s) no se pueden aplicar desde aquí", 1),
          _cache[30] || (_cache[30] = _createTextVNode(" — ", -1)),
          _createElementVNode("code", null, _toDisplayString(_ctx.report.veredicto.bloqueadas.join(" · ")), 1),
          _cache[31] || (_cache[31] = _createTextVNode(". Les falta el documento, y esta pantalla ", -1)),
          _cache[32] || (_cache[32] = _createElementVNode("strong", null, "no lo crea", -1)),
          _cache[33] || (_cache[33] = _createTextVNode(": un ", -1)),
          _cache[34] || (_cache[34] = _createElementVNode("code", null, "binaryTree/", -1)),
          _cache[35] || (_cache[35] = _createTextVNode(" con un solo campo sería un nodo sin padre ni lado, y un ", -1)),
          _cache[36] || (_cache[36] = _createElementVNode("code", null, "users/", -1)),
          _cache[37] || (_cache[37] = _createTextVNode(" con un solo campo una cuenta fantasma. Si debían quedar colocadas, lo que hay que rehacer es la construcción del árbol. ", -1))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("table", _hoisted_10, [
        _cache[40] || (_cache[40] = _createElementVNode("thead", { class: "table-light" }, [
          _createElementVNode("tr", null, [
            _createElementVNode("th", { class: "col-check" }),
            _createElementVNode("th", null, "Cuenta"),
            _createElementVNode("th", null, "Rango ahora"),
            _createElementVNode("th", null, "% binario ahora"),
            _createElementVNode("th", null, "Estado")
          ])
        ], -1)),
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.report.rows, (row) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: row.usernamePK,
              class: _normalizeClass({
              'fila-bloqueada': !!row.bloqueada,
              'fila-marcada': _ctx.estaMarcada(row.usernamePK),
            })
            }, [
              _createElementVNode("td", _hoisted_11, [
                _createElementVNode("input", {
                  type: "checkbox",
                  class: "form-check-input",
                  disabled: !!row.bloqueada,
                  checked: _ctx.estaMarcada(row.usernamePK),
                  title: 
                  row.bloqueada
                    ? row.bloqueada
                    : 'Marcar ' + row.usernamePK + ' para aplicar'
                ,
                  "aria-label": 'Marcar ' + row.usernamePK,
                  onChange: ($event: any) => (_ctx.alternar(row.usernamePK))
                }, null, 40, _hoisted_12)
              ]),
              _createElementVNode("td", null, [
                _createElementVNode("code", _hoisted_13, _toDisplayString(row.usernamePK), 1)
              ]),
              _createElementVNode("td", {
                class: _normalizeClass(row.bloqueada ? '' : row.rankOk ? 'c-ok' : 'c-mal')
              }, [
                (!row.userExists)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_14, [...(_cache[38] || (_cache[38] = [
                      _createTextVNode("— sin ", -1),
                      _createElementVNode("code", null, "users/", -1)
                    ]))]))
                  : (_openBlock(), _createElementBlock("code", _hoisted_15, _toDisplayString(row.rankNow ?? "(sin campo)"), 1))
              ], 2),
              _createElementVNode("td", {
                class: _normalizeClass(row.bloqueada ? '' : row.percentageOk ? 'c-ok' : 'c-mal')
              }, [
                (!row.nodeExists)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_16, [...(_cache[39] || (_cache[39] = [
                      _createTextVNode("— sin nodo de ", -1),
                      _createElementVNode("code", null, "binaryTree", -1)
                    ]))]))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.pinta(row.percentageNow)), 1),
                      (row.percentageType !== 'number')
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 0,
                            class: "badge bg-danger ms-1",
                            title: 
                    'El valor es de tipo ' +
                    row.percentageType +
                    '. El corte compara estricto: una cadena no paga.'
                  
                          }, _toDisplayString(row.percentageType), 9, _hoisted_17))
                        : (row.enDefault)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_18, "default"))
                          : _createCommentVNode("", true)
                    ], 64))
              ], 2),
              _createElementVNode("td", null, [
                (row.bloqueada)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      class: "badge bg-warning text-dark",
                      title: row.bloqueada
                    }, "no aplicable", 8, _hoisted_19))
                  : (row.ok)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_20, "completa"))
                    : (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(_ctx.queFalta(row)), 1))
              ])
            ], 2))
          }), 128))
        ])
      ])
    ]),
    (_ctx.writes.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
          _cache[45] || (_cache[45] = _createElementVNode("strong", null, "Escrito ahora mismo:", -1)),
          _createElementVNode("ul", _hoisted_23, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.writes, (w) => {
              return (_openBlock(), _createElementBlock("li", {
                key: w.usernamePK
              }, [
                _createElementVNode("code", null, _toDisplayString(w.usernamePK), 1),
                (w.wroteRank)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_24, [
                      _cache[41] || (_cache[41] = _createTextVNode(" · rango ", -1)),
                      _createElementVNode("code", null, _toDisplayString(w.rankBefore ?? "(sin campo)"), 1),
                      _cache[42] || (_cache[42] = _createTextVNode(" → ", -1)),
                      _createElementVNode("code", null, _toDisplayString(_ctx.report.rankId), 1)
                    ]))
                  : _createCommentVNode("", true),
                (w.wrotePercentage)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_25, [
                      _cache[43] || (_cache[43] = _createTextVNode(" · binario ", -1)),
                      _createElementVNode("strong", null, _toDisplayString(_ctx.pinta(w.percentageBefore)), 1),
                      _cache[44] || (_cache[44] = _createTextVNode(" → ", -1)),
                      _createElementVNode("strong", null, _toDisplayString(_ctx.report.percentage), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    _cache[46] || (_cache[46] = _createElementVNode("div", { class: "small text-muted" }, [
      _createTextVNode(" La lista de cuentas y el porcentaje salen de "),
      _createElementVNode("code", null, "FIXED_BINARY_PERCENTAGE_ACCOUNTS"),
      _createTextVNode(" y "),
      _createElementVNode("code", null, "FOUNDER_BINARY_PERCENTAGE"),
      _createTextVNode(" ("),
      _createElementVNode("code", null, "functions/src/_constants/founders.ts"),
      _createTextVNode("), que es la MISMA lista que exime al motor de rangos y la misma que comprueban INV-35 e INV-36 al descongelar: se mueven juntas. "),
      _createElementVNode("strong", null, [
        _createElementVNode("code", null, "pflores"),
        _createTextVNode(" no está y no es un olvido")
      ]),
      _createTextVNode(" — es la misma persona que "),
      _createElementVNode("code", null, "pitgtr"),
      _createTextVNode(", y una cuenta con alias nunca recibe nodo binario. ")
    ], -1))
  ]))
}